<template>
  <div class="tablelist-page">
    <div class="tablebox">
      <el-table 
        :cell-style="getTableCellStyle"
        v-loading="tableloading" 
        ref="multipleTable" 
        :data="tableData"
        tooltip-effect="dark" 
        style="width: 100%"
        @selection-change="selectAssetid" 
        @sort-change="sortColumn"
        :default-sort="setDefaultSort"
        @cell-dblclick="editTableColumn"
      >
        <el-table-column 
          v-if="isangecy"
          header-align="left" 
          prop="AssetId" 
          type="selection" 
          width="40" 
          column-key='AssetId' 
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="ASSETID" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-html="scope.row.AssetIdIcon"></span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">{{ scope.row.ProductName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop='SkuMap' :label="$t('jgjk.s266')" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s12')" width="80" header-align="center" align="center">
          <template slot-scope="scope">
            <i class="channelicon" :class="scope.row.ChannelIcon"></i>
          </template>          
        </el-table-column>
        <el-table-column v-if="!showtradeamount" :label="$t('activebrand.t50')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column v-if="!showtradeamount" prop='authorize' :label="$t('jgjk.s21')" width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="CurrentPrice" sortable='custom' width="110">
          <template slot="header">
            {{ $t('jgjk.s23') }}
            <el-tooltip class="item" effect="dark" :content="$t('jgjk.s234')" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.CurrentPrice }}</span>
            <i v-if="scope.row.pricediff == 1" class="el-icon-top report-numcarts-color-red finalpriceupdown">{{ scope.row.discrepancy }}</i>
            <i v-if="scope.row.pricediff == 2" class="el-icon-bottom report-numcarts-color-green finalpriceupdown">{{ scope.row.discrepancy }}</i>
            <i v-if="scope.row.pricediff == 3" class="el-icon-top report-numcarts-color-grey finalpriceupdown">{{ scope.row.discrepancy }}</i>
            <i v-if="scope.row.pricediff == 4" class="el-icon-bottom report-numcarts-color-grey finalpriceupdown">{{ scope.row.discrepancy }}</i>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' width="100" prop="FinalPrice" :label="$t('jgjk.s24')"></el-table-column>
        <el-table-column sortable='custom' prop='MonitorPrice' :label="$t('jgjk.s25')" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='MarginPrice' :label="$t('jgjk.s26')" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='MarginPercent' :label="$t('report.s38')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='sellCount' :label="$t('xfsp.sales')" width="80" show-overflow-tooltip>
          <template slot="header">
            {{ $t('xfsp.sales') }}
            <el-tooltip class="item" effect="dark" content="销量来源为平台商品详情页" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{ scope.row.sellCount }}
          </template>
        </el-table-column>
        <!-- <el-table-column sortable='custom' width="70" prop="activitylevel" label="活跃度">
          <template slot-scope="scope">
            <span :class="scope.row.activitylevel.classname">{{ scope.row.activitylevel.txt }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop='notes' :label="$t('Seller.t13')" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.iseditnotes == false">{{ scope.row.notes }}</span>
            <el-input 
              v-inputfocus
              class="editnoteinput" 
              v-model="scope.row.notes" 
              v-if="scope.row.iseditnotes === true" 
              @blur="setnote(scope.row.AssetId, scope.row.notes, scope.$index)"
              @keyup.enter.native="setnote(scope.row.AssetId, scope.row.notes, scope.$index)"
              size="mini"
              maxlength="20">
            </el-input>
          </template>
        </el-table-column>

        <el-table-column v-if="showtradeamount" sortable='custom' prop='SkuTotalTrade' :label="$t('jgjk.s304')" width="120"></el-table-column>
        <el-table-column v-if="showtradeamount" sortable='custom' prop='SkuTotalAmountStr' width="130">
          <template slot="header">
            {{ $t('jgjk.s303') }}
            <el-tooltip class="item" effect="dark" :content="saletype != 2 ? $t('jgjk.s301') : $t('jgjk.s302')" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>
        </el-table-column>

        <el-table-column v-if="showtsbtn == true" :label="$t('jgjk.s51')" :width="testbuyactive ? 130 : 110">
          <template slot-scope="scope">
            <button v-if="userinfo.role/1 == 0 || userinfo.role/1 == 2" class="editskulinkbtn" type="button" @click="editSkuLink(scope.row)"><i class="el-icon-edit-outline"></i></button>
            <button v-if="userinfo.email == 'david.liu@simplybrand.com'" class="viewactivebrand" type="button" @click="viewUrlDetail(scope.row.AssetId, scope.row.ProductName, scope.row.SkuId)"></button>
            <button v-if="scope.row.tsStatus == null || scope.row.tsStatus == '' || scope.row.tsStatus == undefined" class="tousuxiajia" type="button" @click="submitItem(scope)"></button>
            <button v-if="scope.row.tsStatus >= 1" class="tousuxiajia tousuxiajia_active" type="button" @click="submitItemEdit(scope)"></button>
            <el-popconfirm v-if="testbuyactive" title="确定测买？" @confirm="addTestbuy(scope.row.AssetId)">
              <button slot="reference" class="editskulinkbtn editskulinkbtn1" style="margin-left: 10px;"><i class="el-icon-shopping-cart-1" :class="scope.row.tmstatus != null ? 'testbuy-active' : ''"></i></button>
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column v-if="showtsbtn == false" :label="$t('jgjk.s51')" :width="testbuyactive ? 130 : 110">
          <template slot-scope="scope">
            <button v-if="userinfo.role/1 == 0 || userinfo.role/1 == 2 || userinfo.email == 'demo@simplybrand.com'" class="editskulinkbtn" type="button" @click="editSkuLink(scope.row)"><i class="el-icon-edit-outline"></i></button>
            <button v-if="userinfo.mainid == 6 && subid == 198" class="viewactivebrand" type="button" @click="viewUrlDetail(scope.row.AssetId, scope.row.ProductName, scope.row.SkuId)"></button>
            <el-popconfirm v-if="testbuyactive" title="确定测买？" @confirm="addTestbuy(scope.row.AssetId)">
              <button slot="reference" class="editskulinkbtn editskulinkbtn1" style="margin-left: 10px;"><i class="el-icon-shopping-cart-1" :class="scope.row.tmstatus != null ? 'testbuy-active' : ''"></i></button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.currentpage"
        :page-sizes="[25, 50, 100]"
        :page-size="page.size"
        :total="pagetotal"
        popper-class="pagesizeclass"
        layout="total, prev, pager, next, sizes">
      </el-pagination>
      <el-button 
        type="confirmselect" 
        size="mini" 
        @click="multEditSkuLink()" 
        :disabled="ischeckeditems"
        v-if="isangecy"
      >
        {{ $t('new.t7') }}
      </el-button>
      <el-button v-if="showtsbtn == true" type="confirmselect" plain size="mini" @click="multTousu()" :disabled="ischeckeditems">{{ $t('new.t8') }}</el-button>
    </div>
  
    <el-dialog
      custom-class="editskulink-datafeedback"
      :title="$t('editsku.s1')"
      :visible.sync="editskulinkdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="radio = ''; value = ''">
      <div class="editskulink-body">
        <div class="editskulink-body-table" v-if="multedit == false">
          <table>
            <tr>
              <td width="120">{{ $t('jgjk.s13') }}</td>
              <td>{{currentlinkeditcontent.Series}}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s15') }}</td>
              <td>{{ currentlinkeditcontent.ProductName }}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s266') }}</td>
              <td>{{ currentlinkeditcontent.skuMap }}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s24') }}</td>
              <td>{{ currentlinkeditcontent.FinalPrice }}</td>
            </tr>
            <tr>
              <td>{{ $t('activebrand.t50') }}</td>
              <td>{{ currentlinkeditcontent.ShopName }}</td>
            </tr>
            <tr>
              <td>SKUID</td>
              <td>{{currentlinkeditcontent.SkuId}}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s271') }}</td>
              <td>{{currentlinkeditcontent.SKUName}}</td>
            </tr>
            <tr>
              <td>{{ $t('editsku.s5') }}</td>
              <td>{{currentlinkeditcontent.ConfigValue}}</td>
            </tr>
          </table>
        </div>
        <div class="editskulink-radio">
          <el-radio v-model="newskuidradio" label="-1" size="mini" :border="true">{{ $t('editsku.s2') }}</el-radio>
          <el-radio v-model="newskuidradio" label="0" size="mini" :border="true">{{ $t('editsku.s3') }}</el-radio>
          <el-radio v-model="newskuidradio" label="3" size="mini" :border="true">{{ $t('editsku.s4') }}</el-radio>
          <el-select 
            v-if="newskuidradio/1 === 3" 
            v-model="newskuid" 
            filterable
            clearable
            :placeholder="$t('new.t9')" 
            size="mini">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>          
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editskulinkdialog = false; newskuidradio = ''; newskuid = ''">{{$t('dsfx.t32')}}</el-button>
        <el-button size="mini" 
          :disabled="newskuidradio!='-1'&&newskuidradio!='0'&&newskuid==''" 
          type="primary" @click="editskulinkconfirm()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="editskulink-datafeedback tousu-dialogbox"
      :title="$t('new.t10')"
      :visible.sync="tousudialog1"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <div class="editskulink-body">
        <el-form label-width="100px" size="mini">
          <!-- <el-form-item label="投诉时间"></el-form-item> -->
          <el-form-item :label="$t('new.t11')">
            <el-select v-model="value1" placeholder="请选择" size="mini">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Seller.t13')">
            <el-input
              type="textarea"
              :rows="2"
              placeholder=""
              v-model="textarea">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="tousudialog1 = false;">{{$t('dsfx.t32')}}</el-button>
        <el-button v-if="feedbackSelectedIds == ''" size="mini" type="primary" @click="confirmTousuOne()">{{$t('dsfx.t33')}}</el-button>
        <el-button v-if="feedbackSelectedIds != ''" size="mini" type="primary" @click="updateTou()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Array,
    tableloading: Boolean,
    showtradeamount: Boolean,
    pagetotal: Number,
    setDefaultSort: Object,
    page: Object
  },

  data(){
    return{
      userinfo: JSON.parse(localStorage.getItem("userinfo")).val,
      isangecy: JSON.parse(localStorage.getItem("userinfo")).val.role == 2 
                || JSON.parse(localStorage.getItem("userinfo")).val.role == 0,
      // role==2 or role==0
      // 0 超级用户； 1 普通用户； 2 代理用户
      multedit: false,
      ischeckeditems: true,
      feedbackSelectedIds: '',
      editskulinkdialog: false,
      options: [],
      currentlinkeditcontent: {},
      newskuidradio: '',
      newskuid: '',
      // page: {
      //   currentpage: 1,
      //   size: 25
      // },
      tableorder: this.$route.path.indexOf('PriceMonitoring') != -1 ? 50 : 71,
      saletype: '',
      tousudialog: false,
      tousudialog1: false,
      radio1: '低价',
      textarea: '',
      options1: [{
        value: '1',
        label: this.$t('kpi.s39')
      }, {
        value: '2',
        label: this.$t('kpi.s40')
      }, {
        value: '6',
        label: this.$t('kpi.s47')
      }, {
        value: '7',
        label: this.$t('kpi.s48')
      }, {
        value: '8',
        label: this.$t('kpi.s50')
      }, {
        value: '3',
        label: this.$t('kpi.s41') //失败
      }, {
        value: '5',
        label: this.$t('kpi.s43') //成功
      }],
      value1: '1',
      tousuquery: {},
      showtsbtn: false,
      subid: this.$route.params.Id,
      testbuyactive: this.$route.params.Id == 230 || 
      this.$route.params.Id == 231 || 
      this.$route.params.Id == 232 ||
      this.$route.params.Id == 190 ||
      this.$route.params.Id == 173 ||
      this.$route.params.Id == 317  ? true : false
    }
  },

  mounted(){
    this.checkLevel()
  },

  methods: {

    /**
     * checklevel
     */
    checkLevel: function(){
      let sid = this.$route.params.Id
      let pkglist = JSON.parse(localStorage.getItem("price")).val
      let currentpkg = pkglist.find(o => o.subid/1 === sid/1)
      this.saletype = currentpkg.saletype

      let mapobj = pkglist.filter(item => {
        return item.subid/1 === sid/1
      })
      this.showtsbtn = mapobj[0].tscount == null ? false : true
      /**
       * 2：专业版
       * 3：企业版
       */
      // let ifshowecommerce = currentpkg.level
      // this.showecommerce = ifshowecommerce/1 === 3 ? true : false
    },
    
    /**
     * 列表选择状态
     */
    selectable: function() {
      /**
       * 判断是否可以选中
       * 根据返回状态：暂未判断
       */
      return true
    },

    /**
     * 切换每页显示的条数
     */
    handleSizeChange: function(val){
      this.page.size = val
      this.page.currentpage = 1
      this.$parent.loadTables(this.page.page, val, this.tableorder)
    },

    /**
     * 切换至指定页码
     */
    handleCurrentChange: function(val){
      this.$parent.loadTables(val, this.page.size, this.tableorder)
    },

    /**
     * 排序
     */
    sortColumn: function(column){
      let that = this
      if(column.order == "ascending"){
        switch(column.prop) {
          case 'CurrentPrice':
            that.tableorder = '10'
            break
          case 'FinalPrice':
            that.tableorder = '20'
            break
          case 'MonitorPrice':
            that.tableorder = '30'
            break
          case 'MarginPrice':
            that.tableorder = '40'
            break
          case 'MarginPercent':
            that.tableorder = '50'
            break
          case 'StockNumDisplay':
            that.tableorder = '60'
            break
          case 'SkuTotalTrade':
            that.tableorder = '80'
            break
          case 'SkuTotalAmountStr':
            that.tableorder = '70'
            break
          case 'sellCount':
            that.tableorder = '90'
            break
          case 'activitylevel':
            that.tableorder = '100'
            break
        }
      }
      if(column.order == "descending"){
        switch(column.prop) {
          case 'CurrentPrice':
            that.tableorder = '11'
            break
          case 'FinalPrice':
            that.tableorder = '21'
            break
          case 'MonitorPrice':
            that.tableorder = '31'
            break
          case 'MarginPrice':
            that.tableorder = '41'
            break
          case 'MarginPercent':
            that.tableorder = '51'
            break
          case 'StockNumDisplay':
            that.tableorder = '61'
            break
          case 'SkuTotalTrade':
            that.tableorder = '81'
            break
          case 'SkuTotalAmountStr':
            that.tableorder = '71'
            break
          case 'sellCount':
            that.tableorder = '91'
            break
          case 'activitylevel':
            that.tableorder = '101'
            break
        }
      }
      if(column.order == null){
        that.tableorder = ''
      }
      that.page.currentpage = 1
      that.$parent.loadTables(that.page.page, that.page.size, that.tableorder)
    },

    /**
     * 查看URL详情
     */
    viewUrlDetail: function(mid, name, skuid){
      this.setLocalStorage( "viewurlDetail", '' )
      let MidName = name
      this.setLocalStorage( "viewurlDetail", MidName )
      if(this.$route.name == 'ViewUrl'){
        this.$router.push({name: 'ViewUrlDetail', params: {Id: this.$route.params.Id, SkuId: this.$route.params.SkuId, Mid: mid}})
      }
      if(this.$route.name == 'LowPricedProductsLinks'){
        this.$router.push({name: 'ViewUrlDetail1', params: {Id: this.$route.params.Id, SkuId: skuid, Mid: mid}})
      }
      if(this.$route.name == 'SellerDetail'){
        this.$router.push({name: 'ViewUrlDetail', params: {Id: this.$route.params.Id, SkuId: skuid, Mid: mid}})
      }
    },

    /**
     * 选择SKU
     */
    selectAssetid: function(val){
      this.feedbackSelectedIds = val
      if(this.feedbackSelectedIds != ''){
        this.ischeckeditems = false
      }else{
        this.ischeckeditems = true
      }
    },

    /**
     * 修改链接
     */
    editSkuLink: function(row){
      let that = this
      that.multedit = false
      that.searchSku()
      that.editskulinkdialog = true
      that.options = []
      that.currentlinkeditcontent = row
    },

    /**
     * 批量修改
     */
    multEditSkuLink: function(){
      let that = this
      that.multedit = true
      that.searchSku()
      that.editskulinkdialog = true
      that.options = []
    },

    /**
     * 搜索SKU
     */
    searchSku: function(keyword){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/getSKUBaseInfo'
      let query = {
        subid: that.$route.params.Id,
        SKUName: keyword
      }
      if(keyword == ''){
        return
      }
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: query,
        success: function(rex) {
          that.options = rex.results.map(item => {
            return { 
              value: item.SKUID, 
              label: item.SKUName + '(' + (item.UserSKUCode == null ? '' : item.UserSKUCode + ' | ') + item.SKUID + ')'
            }
          })
        },
        error: function(response) {
          console.log('searchSku', response)
        }
      })      
    },

    /**
     * 确认修改SKU
     */
    editskulinkconfirm: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/updatesku'
      let query = {
        skulist: [],
        subid: that.$route.params.Id/1,
      }
      if(that.multedit == true){
        for(let i=0; i<this.feedbackSelectedIds.length; i++){
          let _query = {
            channelId: this.feedbackSelectedIds[i].ChannelId,
            channel: this.feedbackSelectedIds[i].Channel,
            shopId: this.feedbackSelectedIds[i].ShopId,
            assetid: this.feedbackSelectedIds[i].AssetId,
            skuid: this.feedbackSelectedIds[i].SkuId/1,
            newskuid: that.newskuidradio/1 === 3 ? that.newskuid : that.newskuidradio,
            currentDate: JSON.parse(localStorage.getItem("latestupdatetimeeditsku")).val
          }
          query.skulist.push(_query)
        }
      }else{
        query.skulist[0] = {
          channelId: that.currentlinkeditcontent.ChannelId,
          channel: that.currentlinkeditcontent.Channel,
          shopId: that.currentlinkeditcontent.ShopId,
          assetid: that.currentlinkeditcontent.AssetId,
          skuid: that.currentlinkeditcontent.SkuId/1,
          newskuid: that.newskuidradio/1 === 3 ? that.newskuid : that.newskuidradio,
          currentDate: JSON.parse(localStorage.getItem("latestupdatetimeeditsku")).val
        }
      }
      $.ajax({
        url: url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(query),
        success: function() {
          that.editskulinkdialog = false
          that.options = []
          that.currentlinkeditcontent = {}
          that.newskuid = ''
          that.newskuidradio = ''
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.$parent.loadTables(that.page.page, that.page.size, that.tableorder)
        },
        error: function(response) {
          console.log('editskulinkconfirm', response)
        }
      })
    },

    /**
     * 单条投诉
     */
    submitItem: function(row){
      let that = this
      that.tousuquery = row.row
      // that.value1 = row.row.tsStatus
      that.tousudialog1 = true
    },
    submitItemEdit: function(row){
      let that = this
      that.tousuquery = row.row
      that.value1 = row.row.tsStatus
      that.textarea = row.row.descs
      that.tousudialog1 = true
    },

    /**
    * 批量投诉
    */
    multTousu: function(){
      let that = this
      that.textarea = ''
      that.tousudialog1 = true
    },

    /**
     * 单条投诉/修改
     */
    confirmTousuOne: function(){
      let that = this
      let _url = that.API_URL + '/v3/price/statistics/updatetssku'
      let _query = {
        skulist:[{
          channelId: that.tousuquery.ChannelId,
          itemCode: that.tousuquery.ItemCode,
          shopId: that.tousuquery.ShopId,
          assetid: that.tousuquery.AssetId,
          descs: that.textarea,
          tsdate: that.tousuquery.tsdate != null && that.tousuquery.tsdate != '' && that.tousuquery.tsdate != undefined ? that.tousuquery.tsdate : that.$moment(new Date()).format('YYYY-MM-DD'),
          tscgdate: that.value1 * 1 == 5 ? that.$moment(new Date()).format('YYYY-MM-DD') : '',
          tssbdate: that.value1 * 1 == 3 ? that.$moment(new Date()).format('YYYY-MM-DD') : '',
          ippcode: "",
          status: that.value1 * 1
        }],
        subid: that.$route.params.Id/1
      }
      $.ajax({
        url: _url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(_query),
        success: function(res) {
          console.log(res)
          that.$message({
            message: 'success',
            type: 'success'
          })
          that.tousuquery = {}
          that.tousudialog1 = false
          that.$parent.loadTables(1, that.page.size, that.tableorder)
        },
        error: function(response) {
          console.log('单条投诉', response)
        }
      })
    },

    /**
     * 投诉接口
     */
    updateTou: function(){
      let that = this
      let _url = that.API_URL + '/v3/price/statistics/updatetssku'
      let _lists = that.feedbackSelectedIds
      let _querylists = []
      for(let i=0; i<_lists.length; i++){
        let _l = {
          channelId: _lists[i].ChannelId,
          itemCode: _lists[i].ItemCode,
          shopId: _lists[i].ShopId,
          assetid: _lists[i].AssetId,
          descs: that.textarea,
          tsdate: _lists[i].tsdate != null && _lists[i].tsdate != '' && _lists[i].tsdate != undefined ? _lists[i].tsdate : that.$moment(new Date()).format('YYYY-MM-DD'),
          tscgdate: that.value1 * 1 == 5 ? that.$moment(new Date()).format('YYYY-MM-DD') : '',
          tssbdate: that.value1 * 1 == 3 ? that.$moment(new Date()).format('YYYY-MM-DD') : '',
          ippcode: "",
          status: that.value1 * 1
        }
        _querylists.push(_l)
      }
      let _query = {
        skulist: _querylists,
        subid: that.$route.params.Id/1
      }
      $.ajax({
        url: _url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(_query),
        success: function() {
          that.$message({
            message: 'success',
            type: 'success'
          })
          that.feedbackSelectedIds = ''
          that.tousudialog1 = false
          that.$parent.loadTables(1, that.page.size, that.tableorder)
        },
        error: function(response) {
          console.log('editskulinkconfirm', response)
        }
      })
    },

    /**
     * 测买
     */
    addTestbuy: function(aid){
      let that = this
      let _url = that.API_URL + '/v3/price/testbuy/add'
      let _query = {
        assetId: aid
      }
      $.ajax({
        url: _url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(_query),
        success: function(rex) {
          console.log(rex)
          that.$message({
            message: 'success',
            type: 'success'
          })
        },
        error: function(response) {
          console.log('editskulinkconfirm', response)
        }
      })
    },

    /**
     * 备注
     * @param {*} label 
     * @param {*} notes 
     * @param {*} sid 
     * @param {*} i 
     */
    setnote: function(assetid, notes, i){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/editNotes'
      let postdata= { 
        assetId: assetid,
        notes: notes
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(postdata),
        success: function(data) {
          console.log(data)
          that.tableData[i * 1].iseditnotes = false
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    /**
     * 修改授权
     */
    editTableColumn: function(row, column){
      // if(column.id == 'el-table_1_column_7'){
      //   row.isedittype = true
      // }
      if(column.property == 'notes'){
        row.iseditnotes = true
      }
    },

  }
}
</script>